import config from "../config.json";
import http from "../Services/httpService";

const defaultUserAccount = { mobile: "", subUserId: 0, displayName: "", devices: [] };
function GoogleTokenSend(token) {
    return http.post(`${config.apiUrl}/api/GoogleToken/PostData`, {
        token: token
    })
}

function AuthBale(data) {
    return http.post(`${config.apiUrl}/api/Account/AuthBale`, data, {
        headers: { AllowAnonymous: true }
    });
}


function login(data) {
    return http.post(`${config.apiUrl}/api/Account/Login`, data, {
        headers: { AllowAnonymous: true }
    });
}

function NewDeviceUser(data) {
    return http.post(`${config.apiUrl}/api/Account/NewDeviceUser`, data, {
        headers: { AllowAnonymous: true }
    });
}

function LastMessage(data) {
    return http.post(`${config.apiUrl}/api/UserMessage/List`, data);
}

function ReadMessage(id) {
    return http.post(`${config.apiUrl}/api/UserMessage/ReadMessage?id=${id}`);
}

function LastLocationDeviceUser(idDevice) {
    return http.post(`${config.apiUrl}/api/DataDeviceLast/LastLocationDeviceUser?idDevice=${idDevice}`);
}

function LastLocationAllDeviceUser(data) {
    return http.post(`${config.apiUrl}/api/DataDeviceLast/LastLocationAllDeviceUser`, data);
}

function LastLocationAllDeviceUser2(data) {
    return http.post(`${config.apiUrl}/api/DataDeviceLast/LastLocationAllDeviceUser2`, data);
}

function AddDeviceUser(data) {
    return http.post(`${config.apiUrl}/api/Account/AddDeviceUser`, data);
}

function ChangePassword(data) {
    return http.post(`${config.apiUrl}/api/Account/ChangePassword`, data);
}

function FuelMonthCalculated(idDevice, month, year) {
    return http.post(`${config.apiUrl}/api/v2/ReportFuel/FuelMonthCalculated?idDevice=${idDevice}&month=${month}&year=${year}`);
}

function FuelGetReport(data, modeReport) {
    return http.post(`${config.apiUrl}/api/v2/ReportFuel/FuelGetReport?modeReport=${modeReport}`, data);
}



function UpdateDevice(data) {
    return http.post(`${config.apiUrl}/api/DataDeviceLast/UpdateDevice`, data);
}

function UpdateDevice1(data) {
    let form = new FormData();
    form.append('id', data.id);
    form.append('deviceName', data.deviceName);
    form.append('ModeDevice', data.modeDevice);
    form.append('Icon', data.icon);
    form.append('SimNumber', data.simNumber);
    //form.append('FuelConsumption', data.fuelConsumption);
    //if ('fuelTime' in data)
    //  form.append('FuelTime', data.fuelTime);
    form.append('Mobile', data.mobile);
    //form.append('nationalcode', data.nationalcode);
    form.append('Pelak', data.pelak);
    form.append('File', data.file);
    return http.post(`${config.apiUrl}/api/DataDeviceLast/UpdateDevice`, form);
}
/*
function UpdateDevice2(data) {
    let form = new FormData();
    form.append('id', data.id);
    form.append('deviceName', data.deviceName);
    form.append('ModeDevice', data.modeDevice);
    form.append('Icon', data.icon);
    form.append('SimNumber', data.simNumber);
    form.append('FuelConsumption', data.fuelConsumption);
    if ('fuelTime' in data)
      form.append('FuelTime', data.fuelTime);
    form.append('Mobile', data.mobile);
    form.append('nationalcode', data.nationalcode);
    form.append('Pelak', data.pelak);
    form.append('File', data.file); 
    return http.post(`${config.apiUrl}/api/v2/DataDeviceLast/UpdateDevice`, form);
}
*/
function doExcelDeviceFilter(data) {
    return http.post(`${config.apiUrl}/api/v2/DataDeviceLast/doExcelDeviceFilter`, data);
}
function ChangeProfile(data) {
    return http.post(`${config.apiUrl}/api/Account/ChangeProfile`, data);
}


function GetProfile() {
    return http.post(`${config.apiUrl}/api/Account/GetProfile`);
}



function DeleteDevice(id) {
    return http.post(`${config.apiUrl}/api/DataDeviceLast/DeleteDevice?id=${id}`);
}
//----
function DeviceServicePost(data) {
    return http.post(`${config.apiUrl}/api/DeviceService/post2`, data);
}

function DeviceServiceList(data) {
    return http.post(`${config.apiUrl}/api/DeviceService/list`, data);
}
function DeviceServiceGet(id) {
    return http.get(`${config.apiUrl}/api/DeviceService/Get2?id=${id}`);
}
function DeviceServiceDelete(id) {
    return http.delete(`${config.apiUrl}/api/DeviceService/delete?id=${id}`);
}



//----

function DeviceOilGet(id) {
    return http.get(`${config.apiUrl}/api/DeviceOil/get?id=${id}`);
}

function DeviceOilUpdate(id, oil) {
    return http.post(`${config.apiUrl}/api/DeviceOil/Update?id=${id}&oil=${oil}`);
}

function RequestVerifyCode(mobile) {
    return http.post(`${config.apiUrl}/api/Account/RequestVerifyCode?mobile=${mobile}`, null, {
        headers: { AllowAnonymous: true }
    });
}


function CheckVerifyCode(mobile, code) {
    return http.post(`${config.apiUrl}/api/Account/CheckVerifyCode?mobile=${mobile}&code=${code}`, null, {
        headers: { AllowAnonymous: true }
    });
}

function ChengePassWithVerifyCode(data) {
    return http.post(`${config.apiUrl}/api/Account/ChengePassWithVerifyCode`, data, {
        headers: { AllowAnonymous: true }
    });
}

function ListReport(data) {
    return http.post(`${config.apiUrl}/api/report/List`, data);
}

function reportDay(data) {
    return http.post(`${config.apiUrl}/api/report/reportDay`, data);
}


function ReportTemp(data) {
    return http.post(`${config.apiUrl}/api/reportTemp/List`, data);
}
//

function GetCurrentCreditPrice() {
    return http.get(`${config.apiUrl}/api/Payment/GetCurrentCreditPrice`, {
        headers: { AllowAnonymous: true }
    });
}

function GetCredit() {
    return http.post(`${config.apiUrl}/api/Payment/GetCredit`);
}

function GetCreditUser(seriall) {
    return http.post(`${config.apiUrl}/api/Payment/GetCreditUser?seriall=${seriall}`);
}


function AddCredit(data, seriall, discount) {
    return http.post(`${config.apiUrl}/api/Payment/AddCredit?discount=${discount}`, data);
}

function AddCreditUser(data, seriall, discount) {
    return http.post(`${config.apiUrl}/api/Payment/AddCreditUser?seriall=${seriall}&discount=${discount}`, data);
}

function DiscountCheck(code) {
    return http.post(`${config.apiUrl}/api/Discount/Check?code=${code}`);
}

function PicCarList(data) {
    return http.post(`${config.apiUrl}/api/PicCar/ListAll`, data);
}

function AppGet(id) {
    return http.get(`${config.apiUrl}/api/App/Get?IdApp=${id}`);
}
/**/
function UserAreaGet(id) {
    return http.get(`${config.apiUrl}/api/UserArea/Get?Id=${id}`);
}
function UserAreaPost(data) {
    return http.post(`${config.apiUrl}/api/UserArea/post`, data);
}
function UserAreaList() {
    return http.post(`${config.apiUrl}/api/UserArea/List`);
}
function UserAreaDelete(id) {
    return http.delete(`${config.apiUrl}/api/UserArea/delete?id=${id}`);
}
/* */
function UserAccountList() {
    return http.post(`${config.apiUrl}/api/UserAccount/List`);
}
function UserAccountPost(data) {
    return http.post(`${config.apiUrl}/api/UserAccount/post`, data);
}
function UserAccountGet(id) {
    return http.get(`${config.apiUrl}/api/UserAccount/Get?Id=${id}`);
}
function UserAccountDelete(id) {
    return http.delete(`${config.apiUrl}/api/UserAccount/delete?Id=${id}`);
}
const hideMenu = () => {
    document.getElementById('responsive-navbar-nav').classList.remove("show");
    //document.getElementById('dd').classList.remove("show");
    let x = document.getElementsByClassName("myDropDown");
    for (let i = 0; i < x.length; i++) {
        x[i].classList.remove("show");
        //console.log(x[i].classList);
    }
}
export default {
    hideMenu,
    UserAreaGet, UserAreaPost, UserAreaList, UserAreaDelete,
    UserAccountDelete, UserAccountList, UserAccountPost, UserAccountGet, defaultUserAccount,

    GoogleTokenSend,
    PicCarList,
    AppGet,
    login, AuthBale
    , NewDeviceUser
    , LastLocationDeviceUser
    , LastLocationAllDeviceUser, LastLocationAllDeviceUser2
    , AddDeviceUser, ListReport, DeleteDevice
    , UpdateDevice, UpdateDevice1
    //,UpdateDevice2
    , DeviceOilGet, DeviceOilUpdate, DeviceServicePost, DeviceServiceList, DeviceServiceGet, DeviceServiceDelete
    , ChangePassword, ChangeProfile, GetProfile
    , RequestVerifyCode, CheckVerifyCode, ChengePassWithVerifyCode

    , LastMessage, ReadMessage

    , GetCreditUser
    , GetCredit, AddCredit, GetCurrentCreditPrice, AddCreditUser, DiscountCheck
    , doExcelDeviceFilter

    , ReportTemp, reportDay, FuelMonthCalculated, FuelGetReport

};
